import { size, trim } from 'lodash'

export const getCharCount = (newVal) => {
  return newVal ? size(sanitizeText(newVal)) : 0
}

const sanitizeText = (body) => {
  const tagless = body.replace(/(<([^>]+)>)/gi, '')
  const sanity = tagless.replace(/&#160;/g, ' ') // empty-space
  return trim(sanity)
}
